/*
 * Copyright (c) 2020.
 * Simon
 */

import {SERVER_API_PLATFORMJK} from '../../../constans/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../../utils/headers";
import {FANPAGE_GET_HEARS_FAILURE, FANPAGE_GET_HEARS_REQUEST, FANPAGE_GET_HEARS_SUCCESS} from "../../../types/index";

const FanpageGetHearAction = (fanpageId, actor = null, currentPage = 1, limit = 20) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_PLATFORMJK}/api/pages/${fanpageId}/hears?limit=${limit}&page=${currentPage}&sort=-updated_at`
        },
        method: "GET",
        headers: (headers()),
        types: [
            FANPAGE_GET_HEARS_REQUEST,
            {
                type: FANPAGE_GET_HEARS_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": FANPAGE_GET_HEARS_SUCCESS,
                        "actor": actor,
                        "fanpage_id": fanpageId,
                        "id": fanpageId,
                        "data": data,
                    };
                }
            },
            {
                type: FANPAGE_GET_HEARS_FAILURE,
                payload: (action, state, res) => {
                    return res.json()
                },
            }
        ]
    }
});

export {FanpageGetHearAction}

